import Header from "../Header/Header";
import logo from "../Assets/Image/i4smartlogo.png";
import log_Out_Img from "../Assets/Image/logout.png";
import { useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Drawer } from "@mui/material";
import { useState } from "react";
import { Box } from "@mui/system";
import bottom_logo from "../Assets/Image/i4.png";
import { Outlet, useLocation, Link, useNavigate } from "react-router-dom";
import { First_links, Employee_First_links } from "./components";
import "../Assets/Scss/SideBar.scss";

import { useDispatch, useSelector } from "react-redux";
import { LogOut } from "../store/actions";
import { stopProxyEmployeeUrl } from "../Library/URLs";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IoLogOutOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import axios from "axios";
import { payrollActions } from "../store";
import { v4 as uuid } from "uuid";

const MainPageRoutes = () => {
  const [GetSubIndex, setGetSubIndex] = useState("");

  // const Svg_List = [
  //     <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <path fill-rule="evenodd" clip-rule="evenodd"
  //               d="M8.79745 25.9502H4.0116C1.63052 25.9502 0.481445 24.8485 0.481445 22.574V3.85711C0.481445 1.58265 1.64237 0.480957 4.0116 0.480957H8.79745C11.1785 0.480957 12.3276 1.58265 12.3276 3.85711V22.574C12.3276 24.8485 11.1667 25.9502 8.79745 25.9502ZM4.0116 2.25788C2.50714 2.25788 2.25837 2.66065 2.25837 3.85711V22.574C2.25837 23.7705 2.50714 24.1733 4.0116 24.1733H8.79745C10.3019 24.1733 10.5507 23.7705 10.5507 22.574V3.85711C10.5507 2.66065 10.3019 2.25788 8.79745 2.25788H4.0116ZM22.4195 15.2886H17.6337C15.2526 15.2886 14.1035 14.187 14.1035 11.9125V3.85711C14.1035 1.58265 15.2644 0.480957 17.6337 0.480957H22.4195C24.8006 0.480957 25.9497 1.58265 25.9497 3.85711V11.9125C25.9497 14.187 24.7887 15.2886 22.4195 15.2886ZM17.6337 2.25788C16.1292 2.25788 15.8804 2.66065 15.8804 3.85711V11.9125C15.8804 13.109 16.1292 13.5117 17.6337 13.5117H22.4195C23.924 13.5117 24.1727 13.109 24.1727 11.9125V3.85711C24.1727 2.66065 23.924 2.25788 22.4195 2.25788H17.6337ZM17.6337 25.9496H22.4195C24.7887 25.9496 25.9497 24.8479 25.9497 22.5734V20.4411C25.9497 18.1666 24.8006 17.0649 22.4195 17.0649H17.6337C15.2644 17.0649 14.1035 18.1666 14.1035 20.4411V22.5734C14.1035 24.8479 15.2526 25.9496 17.6337 25.9496ZM15.8804 20.4411C15.8804 19.2446 16.1292 18.8419 17.6337 18.8419H22.4195C23.924 18.8419 24.1727 19.2446 24.1727 20.4411V22.5734C24.1727 23.7699 23.924 24.1726 22.4195 24.1726H17.6337C16.1292 24.1726 15.8804 23.7699 15.8804 22.5734V20.4411Z"
  //               fill="none"/>
  //     </svg>,
  //     <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <path
  //             d="M12.2163 13.9036H9.0142C8.25295 13.9036 7.63672 14.5198 7.63672 15.281V21.4677H12.2163V13.9036V13.9036Z"
  //             stroke="" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  //         <path
  //             d="M15.4197 8.40552H13.583C12.8218 8.40552 12.2056 9.02179 12.2056 9.78304V21.4556H16.7852V9.78304C16.7852 9.02179 16.181 8.40552 15.4197 8.40552Z"
  //             stroke="" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  //         <path d="M19.9955 15.9575H16.7935V21.4555H21.3731V17.335C21.361 16.5738 20.7447 15.9575 19.9955 15.9575Z"
  //               stroke="" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  //         <path
  //             d="M10.8748 27.0141H18.1248C24.1665 27.0141 26.5832 24.5974 26.5832 18.5557V11.3057C26.5832 5.26408 24.1665 2.84741 18.1248 2.84741H10.8748C4.83317 2.84741 2.4165 5.26408 2.4165 11.3057V18.5557C2.4165 24.5974 4.83317 27.0141 10.8748 27.0141Z"
  //             stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  //     </svg>,
  //     <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <path
  //             d="M19.8335 24.9307H8.16683C3.50016 24.9307 2.3335 23.764 2.3335 19.0973V9.764C2.3335 5.09733 3.50016 3.93066 8.16683 3.93066H19.8335C24.5002 3.93066 25.6668 5.09733 25.6668 9.764V19.0973C25.6668 23.764 24.5002 24.9307 19.8335 24.9307Z"
  //             stroke="" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
  //         <path d="M16.3335 9.76392H22.1668" stroke="" stroke-width="1.75" stroke-linecap="round"
  //               stroke-linejoin="round"/>
  //         <path d="M17.5 14.4307H22.1667" stroke="" stroke-width="1.75" stroke-linecap="round"
  //               stroke-linejoin="round"/>
  //         <path d="M19.8335 19.0974H22.1668" stroke="" stroke-width="1.75" stroke-linecap="round"
  //               stroke-linejoin="round"/>
  //         <path
  //             d="M9.91733 13.6022C11.0836 13.6022 12.029 12.6568 12.029 11.4906C12.029 10.3243 11.0836 9.37891 9.91733 9.37891C8.75109 9.37891 7.80566 10.3243 7.80566 11.4906C7.80566 12.6568 8.75109 13.6022 9.91733 13.6022Z"
  //             stroke="" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
  //         <path
  //             d="M14.0002 19.482C13.8368 17.7903 12.4952 16.4603 10.8035 16.3086C10.2202 16.2503 9.62516 16.2503 9.03016 16.3086C7.3385 16.472 5.99683 17.7903 5.8335 19.482"
  //             stroke="" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
  //     </svg>,
  //     <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <path
  //             d="M21.9194 26.5548C20.8561 26.869 19.5994 27.014 18.1252 27.014H10.8752C9.40105 27.014 8.14439 26.869 7.08105 26.5548C7.34689 23.4131 10.5731 20.936 14.5002 20.936C18.4273 20.936 21.6536 23.4131 21.9194 26.5548Z"
  //             stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  //         <path
  //             d="M18.1248 2.84741H10.8748C4.83317 2.84741 2.4165 5.26408 2.4165 11.3057V18.5557C2.4165 23.1232 3.794 25.6245 7.08067 26.5549C7.3465 23.4132 10.5728 20.9361 14.4998 20.9361C18.4269 20.9361 21.6532 23.4132 21.919 26.5549C25.2057 25.6245 26.5832 23.1232 26.5832 18.5557V11.3057C26.5832 5.26408 24.1665 2.84741 18.1248 2.84741ZM14.4998 17.5528C12.1073 17.5528 10.174 15.6074 10.174 13.2149C10.174 10.8224 12.1073 8.88908 14.4998 8.88908C16.8923 8.88908 18.8257 10.8224 18.8257 13.2149C18.8257 15.6074 16.8923 17.5528 14.4998 17.5528Z"
  //             stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  //         <path
  //             d="M18.826 13.2148C18.826 15.6073 16.8927 17.5526 14.5002 17.5526C12.1077 17.5526 10.1743 15.6073 10.1743 13.2148C10.1743 10.8223 12.1077 8.88892 14.5002 8.88892C16.8927 8.88892 18.826 10.8223 18.826 13.2148Z"
  //             stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  //     </svg>,
  //     <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <path
  //             d="M13.5511 17.7855C11.2135 17.7855 9.31641 15.8884 9.31641 13.5508C9.31641 11.2133 11.2135 9.31616 13.5511 9.31616C15.8886 9.31616 17.7858 11.2133 17.7858 13.5508C17.7858 15.8884 15.8886 17.7855 13.5511 17.7855ZM13.5511 11.01C12.1508 11.01 11.0103 12.1506 11.0103 13.5508C11.0103 14.9511 12.1508 16.0916 13.5511 16.0916C14.9513 16.0916 16.0919 14.9511 16.0919 13.5508C16.0919 12.1506 14.9513 11.01 13.5511 11.01Z"
  //             fill=""/>
  //         <path
  //             d="M17.1754 25.0582C16.9383 25.0582 16.7011 25.0243 16.464 24.9678C15.7638 24.7759 15.1766 24.3354 14.804 23.7144L14.6685 23.4885C14.0022 22.3367 13.0875 22.3367 12.4213 23.4885L12.2971 23.7031C11.9244 24.3354 11.3372 24.7871 10.6371 24.9678C9.92565 25.1598 9.19164 25.0582 8.57055 24.6855L6.62825 23.5676C5.93941 23.1723 5.44254 22.5287 5.22798 21.7495C5.02472 20.9703 5.12635 20.1685 5.52159 19.4797C5.84907 18.9038 5.93941 18.3843 5.74744 18.0568C5.55547 17.7294 5.06989 17.5374 4.40363 17.5374C2.75494 17.5374 1.41113 16.1936 1.41113 14.5449V12.5574C1.41113 10.9087 2.75494 9.56491 4.40363 9.56491C5.06989 9.56491 5.55547 9.37294 5.74744 9.04546C5.93941 8.71798 5.86036 8.19852 5.52159 7.62261C5.12635 6.93377 5.02472 6.12071 5.22798 5.35282C5.43125 4.57364 5.92812 3.92997 6.62825 3.53474L8.58184 2.41678C9.85789 1.66019 11.5405 2.10059 12.3084 3.39923L12.4439 3.62508C13.1101 4.77691 14.0248 4.77691 14.6911 3.62508L14.8153 3.41052C15.5832 2.10059 17.2657 1.66019 18.5531 2.42807L20.4954 3.54603C21.1842 3.94126 21.6811 4.58493 21.8957 5.36411C22.0989 6.14329 21.9973 6.94506 21.6021 7.6339C21.2746 8.20981 21.1842 8.72927 21.3762 9.05675C21.5682 9.38423 22.0538 9.5762 22.72 9.5762C24.3687 9.5762 25.7125 10.92 25.7125 12.5687V14.5562C25.7125 16.2049 24.3687 17.5487 22.72 17.5487C22.0538 17.5487 21.5682 17.7407 21.3762 18.0681C21.1842 18.3956 21.2633 18.9151 21.6021 19.491C21.9973 20.1798 22.1102 20.9929 21.8957 21.7608C21.6924 22.5399 21.1955 23.1836 20.4954 23.5789L18.5418 24.6968C18.1127 24.9339 17.6497 25.0582 17.1754 25.0582ZM13.5505 20.88C14.5556 20.88 15.4928 21.5123 16.1365 22.6303L16.2607 22.8448C16.3962 23.082 16.6221 23.2514 16.8931 23.3191C17.1641 23.3869 17.4351 23.353 17.661 23.2175L19.6146 22.0882C19.9082 21.9189 20.134 21.6365 20.2244 21.2978C20.3147 20.959 20.2695 20.6089 20.1002 20.3153C19.4565 19.2087 19.3774 18.0681 19.8743 17.1986C20.3712 16.3291 21.3988 15.8322 22.6861 15.8322C23.4088 15.8322 23.9848 15.2563 23.9848 14.5336V12.5461C23.9848 11.8347 23.4088 11.2475 22.6861 11.2475C21.3988 11.2475 20.3712 10.7506 19.8743 9.8811C19.3774 9.01158 19.4565 7.87104 20.1002 6.76438C20.2695 6.47078 20.3147 6.12071 20.2244 5.78194C20.134 5.44316 19.9195 5.17214 19.6259 4.99146L17.6723 3.87351C17.1867 3.57991 16.543 3.74929 16.2494 4.24616L16.1252 4.46072C15.4815 5.57867 14.5443 6.21105 13.5392 6.21105C12.5342 6.21105 11.5969 5.57867 10.9533 4.46072L10.829 4.23487C10.5467 3.76059 9.91436 3.5912 9.42878 3.87351L7.47518 5.00276C7.18158 5.17214 6.95573 5.45445 6.86539 5.79323C6.77505 6.132 6.82022 6.48207 6.98961 6.77567C7.63328 7.88233 7.71233 9.02287 7.21546 9.89239C6.71859 10.7619 5.69098 11.2588 4.40363 11.2588C3.68092 11.2588 3.105 11.8347 3.105 12.5574V14.5449C3.105 15.2563 3.68092 15.8435 4.40363 15.8435C5.69098 15.8435 6.71859 16.3404 7.21546 17.2099C7.71233 18.0794 7.63328 19.22 6.98961 20.3266C6.82022 20.6202 6.77505 20.9703 6.86539 21.3091C6.95573 21.6478 7.17029 21.9189 7.46389 22.0995L9.41749 23.2175C9.65463 23.3643 9.93694 23.3982 10.1967 23.3304C10.4677 23.2627 10.6935 23.082 10.8403 22.8448L10.9646 22.6303C11.6082 21.5236 12.5455 20.88 13.5505 20.88Z"
  //             fill=""/>
  //     </svg>,
  //     < DomainIcon/>,
  //     <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <path
  //             d="M13.7314 13.1219C13.6975 13.1219 13.6749 13.1219 13.6411 13.1219C13.5846 13.1106 13.5056 13.1106 13.4378 13.1219C10.163 13.0203 7.68994 10.4456 7.68994 7.27241C7.68994 4.04276 10.3211 1.41162 13.5507 1.41162C16.7804 1.41162 19.4115 4.04276 19.4115 7.27241C19.4002 10.4456 16.9159 13.0203 13.7653 13.1219C13.754 13.1219 13.7427 13.1219 13.7314 13.1219ZM13.5507 3.10549C11.2584 3.10549 9.38381 4.98004 9.38381 7.27241C9.38381 9.5309 11.1454 11.349 13.3926 11.428C13.4491 11.4167 13.6072 11.4167 13.754 11.428C15.9673 11.3264 17.7064 9.50832 17.7176 7.27241C17.7176 4.98004 15.8431 3.10549 13.5507 3.10549Z"
  //             fill="black"/>
  //         <path
  //             d="M13.7422 25.4644C11.5289 25.4644 9.3043 24.8998 7.62173 23.7706C6.05207 22.7316 5.19385 21.3088 5.19385 19.7617C5.19385 18.2147 6.05207 16.7805 7.62173 15.7303C11.0095 13.4831 16.4976 13.4831 19.8628 15.7303C21.4211 16.7692 22.2906 18.1921 22.2906 19.7391C22.2906 21.2862 21.4324 22.7204 19.8628 23.7706C18.1689 24.8998 15.9556 25.4644 13.7422 25.4644ZM8.559 17.1532C7.47492 17.8759 6.88772 18.8019 6.88772 19.773C6.88772 20.7329 7.48622 21.6589 8.559 22.3703C11.3708 24.2561 16.1137 24.2561 18.9255 22.3703C20.0096 21.6476 20.5968 20.7216 20.5968 19.7504C20.5968 18.7906 19.9983 17.8646 18.9255 17.1532C16.1137 15.2786 11.3708 15.2786 8.559 17.1532Z"
  //             fill="black"/>
  //     </svg>
  // ]
  const Svg_List = [
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.79745 25.9502H4.0116C1.63052 25.9502 0.481445 24.8485 0.481445 22.574V3.85711C0.481445 1.58265 1.64237 0.480957 4.0116 0.480957H8.79745C11.1785 0.480957 12.3276 1.58265 12.3276 3.85711V22.574C12.3276 24.8485 11.1667 25.9502 8.79745 25.9502ZM4.0116 2.25788C2.50714 2.25788 2.25837 2.66065 2.25837 3.85711V22.574C2.25837 23.7705 2.50714 24.1733 4.0116 24.1733H8.79745C10.3019 24.1733 10.5507 23.7705 10.5507 22.574V3.85711C10.5507 2.66065 10.3019 2.25788 8.79745 2.25788H4.0116ZM22.4195 15.2886H17.6337C15.2526 15.2886 14.1035 14.187 14.1035 11.9125V3.85711C14.1035 1.58265 15.2644 0.480957 17.6337 0.480957H22.4195C24.8006 0.480957 25.9497 1.58265 25.9497 3.85711V11.9125C25.9497 14.187 24.7887 15.2886 22.4195 15.2886ZM17.6337 2.25788C16.1292 2.25788 15.8804 2.66065 15.8804 3.85711V11.9125C15.8804 13.109 16.1292 13.5117 17.6337 13.5117H22.4195C23.924 13.5117 24.1727 13.109 24.1727 11.9125V3.85711C24.1727 2.66065 23.924 2.25788 22.4195 2.25788H17.6337ZM17.6337 25.9496H22.4195C24.7887 25.9496 25.9497 24.8479 25.9497 22.5734V20.4411C25.9497 18.1666 24.8006 17.0649 22.4195 17.0649H17.6337C15.2644 17.0649 14.1035 18.1666 14.1035 20.4411V22.5734C14.1035 24.8479 15.2526 25.9496 17.6337 25.9496ZM15.8804 20.4411C15.8804 19.2446 16.1292 18.8419 17.6337 18.8419H22.4195C23.924 18.8419 24.1727 19.2446 24.1727 20.4411V22.5734C24.1727 23.7699 23.924 24.1726 22.4195 24.1726H17.6337C16.1292 24.1726 15.8804 23.7699 15.8804 22.5734V20.4411Z"
        fill="none"
      />
    </svg>,
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.479 10.4084C10.8857 10.4084 10.3056 10.5844 9.81229 10.914C9.31895 11.2437 8.93443 11.7122 8.70737 12.2604C8.4803 12.8086 8.42089 13.4118 8.53665 13.9937C8.6524 14.5757 8.93813 15.1102 9.35768 15.5298C9.77724 15.9493 10.3118 16.235 10.8937 16.3508C11.4757 16.4666 12.0789 16.4071 12.6271 16.1801C13.1752 15.953 13.6438 15.5685 13.9734 15.0752C14.3031 14.5818 14.479 14.0018 14.479 13.4084C14.479 12.6128 14.1629 11.8497 13.6003 11.2871C13.0377 10.7245 12.2747 10.4084 11.479 10.4084ZM11.479 14.4084C11.2812 14.4084 11.0879 14.3498 10.9234 14.2399C10.759 14.13 10.6308 13.9739 10.5551 13.7911C10.4794 13.6084 10.4596 13.4073 10.4982 13.2134C10.5368 13.0194 10.632 12.8412 10.7719 12.7013C10.9117 12.5615 11.0899 12.4662 11.2839 12.4277C11.4779 12.3891 11.679 12.4089 11.8617 12.4846C12.0444 12.5603 12.2006 12.6884 12.3105 12.8529C12.4204 13.0173 12.479 13.2107 12.479 13.4084C12.479 13.6737 12.3736 13.928 12.1861 14.1156C11.9986 14.3031 11.7442 14.4084 11.479 14.4084ZM10.769 8.11845C10.8641 8.20949 10.9763 8.28085 11.099 8.32845C11.2187 8.38135 11.3481 8.40868 11.479 8.40868C11.6099 8.40868 11.7393 8.38135 11.859 8.32845C11.9818 8.28085 12.0939 8.20949 12.189 8.11845L14.479 5.86845C14.6726 5.67484 14.7814 5.41225 14.7814 5.13845C14.7814 4.86464 14.6726 4.60206 14.479 4.40845C14.2854 4.21484 14.0228 4.10607 13.749 4.10607C13.4752 4.10607 13.2126 4.21484 13.019 4.40845L12.479 4.99845V1.40845C12.479 1.14323 12.3736 0.888877 12.1861 0.70134C11.9986 0.513804 11.7442 0.408447 11.479 0.408447C11.2138 0.408447 10.9594 0.513804 10.7719 0.70134C10.5844 0.888877 10.479 1.14323 10.479 1.40845V4.99845L9.939 4.40845C9.7454 4.21484 9.48281 4.10607 9.209 4.10607C8.9352 4.10607 8.67261 4.21484 8.479 4.40845C8.2854 4.60206 8.17663 4.86464 8.17663 5.13845C8.17663 5.41225 8.2854 5.67484 8.479 5.86845L10.769 8.11845ZM18.479 13.4084C18.479 13.2107 18.4204 13.0173 18.3105 12.8529C18.2006 12.6884 18.0444 12.5603 17.8617 12.4846C17.679 12.4089 17.4779 12.3891 17.2839 12.4277C17.0899 12.4662 16.9117 12.5615 16.7719 12.7013C16.632 12.8412 16.5368 13.0194 16.4982 13.2134C16.4596 13.4073 16.4794 13.6084 16.5551 13.7911C16.6308 13.9739 16.759 14.13 16.9234 14.2399C17.0879 14.3498 17.2812 14.4084 17.479 14.4084C17.7442 14.4084 17.9986 14.3031 18.1861 14.1156C18.3736 13.928 18.479 13.6737 18.479 13.4084ZM19.479 6.40845H16.479C16.2138 6.40845 15.9594 6.5138 15.7719 6.70134C15.5844 6.88888 15.479 7.14323 15.479 7.40845C15.479 7.67366 15.5844 7.92802 15.7719 8.11555C15.9594 8.30309 16.2138 8.40845 16.479 8.40845H19.479C19.7442 8.40845 19.9986 8.5138 20.1861 8.70134C20.3736 8.88888 20.479 9.14323 20.479 9.40845V17.4084C20.479 17.6737 20.3736 17.928 20.1861 18.1156C19.9986 18.3031 19.7442 18.4084 19.479 18.4084H3.479C3.21379 18.4084 2.95943 18.3031 2.7719 18.1156C2.58436 17.928 2.479 17.6737 2.479 17.4084V9.40845C2.479 9.14323 2.58436 8.88888 2.7719 8.70134C2.95943 8.5138 3.21379 8.40845 3.479 8.40845H6.479C6.74422 8.40845 6.99857 8.30309 7.18611 8.11555C7.37365 7.92802 7.479 7.67366 7.479 7.40845C7.479 7.14323 7.37365 6.88888 7.18611 6.70134C6.99857 6.5138 6.74422 6.40845 6.479 6.40845H3.479C2.68335 6.40845 1.92029 6.72452 1.35768 7.28713C0.795074 7.84974 0.479004 8.6128 0.479004 9.40845V17.4084C0.479004 18.2041 0.795074 18.9672 1.35768 19.5298C1.92029 20.0924 2.68335 20.4084 3.479 20.4084H19.479C20.2747 20.4084 21.0377 20.0924 21.6003 19.5298C22.1629 18.9672 22.479 18.2041 22.479 17.4084V9.40845C22.479 8.6128 22.1629 7.84974 21.6003 7.28713C21.0377 6.72452 20.2747 6.40845 19.479 6.40845ZM4.479 13.4084C4.479 13.6062 4.53765 13.7996 4.64753 13.964C4.75742 14.1285 4.91359 14.2566 5.09632 14.3323C5.27905 14.408 5.48011 14.4278 5.67409 14.3892C5.86808 14.3506 6.04626 14.2554 6.18611 14.1156C6.32596 13.9757 6.4212 13.7975 6.45979 13.6035C6.49837 13.4096 6.47857 13.2085 6.40288 13.0258C6.3272 12.843 6.19902 12.6869 6.03457 12.577C5.87012 12.4671 5.67678 12.4084 5.479 12.4084C5.21379 12.4084 4.95943 12.5138 4.7719 12.7013C4.58436 12.8889 4.479 13.1432 4.479 13.4084Z"
        fill=""
      />
    </svg>,
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.46704 0.397461C9.52791 0.397461 10.5453 0.818888 11.2955 1.56903C12.0456 2.31918 12.467 3.3366 12.467 4.39746C12.467 5.45833 12.0456 6.47574 11.2955 7.22589C10.5453 7.97603 9.52791 8.39746 8.46704 8.39746C7.40618 8.39746 6.38876 7.97603 5.63861 7.22589C4.88847 6.47574 4.46704 5.45833 4.46704 4.39746C4.46704 3.3366 4.88847 2.31918 5.63861 1.56903C6.38876 0.818888 7.40618 0.397461 8.46704 0.397461ZM8.46704 2.39746C7.93661 2.39746 7.4279 2.60817 7.05283 2.98325C6.67775 3.35832 6.46704 3.86703 6.46704 4.39746C6.46704 4.92789 6.67775 5.4366 7.05283 5.81167C7.4279 6.18675 7.93661 6.39746 8.46704 6.39746C8.99747 6.39746 9.50618 6.18675 9.88125 5.81167C10.2563 5.4366 10.467 4.92789 10.467 4.39746C10.467 3.86703 10.2563 3.35832 9.88125 2.98325C9.50618 2.60817 8.99747 2.39746 8.46704 2.39746ZM8.46704 9.39746C11.137 9.39746 16.467 10.7275 16.467 13.3975V16.3975H0.467041V13.3975C0.467041 10.7275 5.79704 9.39746 8.46704 9.39746ZM8.46704 11.2975C5.49704 11.2975 2.36704 12.7575 2.36704 13.3975V14.4975H14.567V13.3975C14.567 12.7575 11.437 11.2975 8.46704 11.2975Z"
        fill=""
      />
    </svg>,
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.467 0.397461C11.9716 0.397301 12.4576 0.587867 12.8276 0.930958C13.1976 1.27405 13.4242 1.74431 13.462 2.24746L13.467 2.39746V6.39746H16.467C16.9716 6.3973 17.4576 6.58787 17.8276 6.93096C18.1976 7.27405 18.4242 7.74431 18.462 8.24746L18.467 8.39746V16.3975H19.467C19.7219 16.3977 19.9671 16.4953 20.1524 16.6703C20.3377 16.8453 20.4493 17.0844 20.4642 17.3389C20.4791 17.5933 20.3964 17.8438 20.2328 18.0393C20.0692 18.2347 19.8371 18.3604 19.584 18.3905L19.467 18.3975H1.46703C1.21215 18.3972 0.967 18.2996 0.781664 18.1246C0.596327 17.9496 0.484797 17.7105 0.46986 17.4561C0.454923 17.2016 0.537706 16.9511 0.701297 16.7556C0.864887 16.5602 1.09694 16.4346 1.35003 16.4045L1.46703 16.3975H2.46703V2.39746C2.46687 1.89288 2.65744 1.40689 3.00053 1.03691C3.34362 0.666932 3.81388 0.440304 4.31703 0.402461L4.46703 0.397461H11.467ZM16.467 8.39746H13.467V16.3975H16.467V8.39746ZM11.467 2.39746H4.46703V16.3975H11.467V2.39746ZM9.46703 12.3975V14.3975H6.46703V12.3975H9.46703ZM9.46703 8.39746V10.3975H6.46703V8.39746H9.46703ZM9.46703 4.39746V6.39746H6.46703V4.39746H9.46703Z"
        fill=""
      />
    </svg>,
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5H6M5 11H11M9 15H11M13 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H10L15 6V17C15 17.5304 14.7893 18.0391 14.4142 18.4142C14.0391 18.7893 13.5304 19 13 19Z"
        stroke=""
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.5 15.38 14.93 16.28C13.5294 17.396 11.7909 18.0026 10 18C8.14 18 6.43 17.36 5.07 16.28ZM16.36 14.83C14.93 13.09 11.46 12.5 10 12.5C8.54 12.5 5.07 13.09 3.64 14.83C2.57618 13.4446 1.99967 11.7467 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 11.82 17.38 13.5 16.36 14.83ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM10 9C9.60218 9 9.22064 8.84196 8.93934 8.56066C8.65804 8.27936 8.5 7.89782 8.5 7.5C8.5 7.10218 8.65804 6.72064 8.93934 6.43934C9.22064 6.15804 9.60218 6 10 6C10.3978 6 10.7794 6.15804 11.0607 6.43934C11.342 6.72064 11.5 7.10218 11.5 7.5C11.5 7.89782 11.342 8.27936 11.0607 8.56066C10.7794 8.84196 10.3978 9 10 9Z"
        fill=""
      />
    </svg>,
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.325 2.317C8.751 0.561 11.249 0.561 11.675 2.317C11.7389 2.5808 11.8642 2.82578 12.0407 3.032C12.2172 3.23822 12.4399 3.39985 12.6907 3.50375C12.9414 3.60764 13.2132 3.65085 13.4838 3.62987C13.7544 3.60889 14.0162 3.5243 14.248 3.383C15.791 2.443 17.558 4.209 16.618 5.753C16.4769 5.98466 16.3924 6.24634 16.3715 6.51677C16.3506 6.78721 16.3938 7.05877 16.4975 7.30938C16.6013 7.55999 16.7627 7.78258 16.9687 7.95905C17.1747 8.13553 17.4194 8.26091 17.683 8.325C19.439 8.751 19.439 11.249 17.683 11.675C17.4192 11.7389 17.1742 11.8642 16.968 12.0407C16.7618 12.2172 16.6001 12.4399 16.4963 12.6907C16.3924 12.9414 16.3491 13.2132 16.3701 13.4838C16.3911 13.7544 16.4757 14.0162 16.617 14.248C17.557 15.791 15.791 17.558 14.247 16.618C14.0153 16.4769 13.7537 16.3924 13.4832 16.3715C13.2128 16.3506 12.9412 16.3938 12.6906 16.4975C12.44 16.6013 12.2174 16.7627 12.0409 16.9687C11.8645 17.1747 11.7391 17.4194 11.675 17.683C11.249 19.439 8.751 19.439 8.325 17.683C8.26108 17.4192 8.13578 17.1742 7.95929 16.968C7.7828 16.7618 7.56011 16.6001 7.30935 16.4963C7.05859 16.3924 6.78683 16.3491 6.51621 16.3701C6.24559 16.3911 5.98375 16.4757 5.752 16.617C4.209 17.557 2.442 15.791 3.382 14.247C3.5231 14.0153 3.60755 13.7537 3.62848 13.4832C3.64942 13.2128 3.60624 12.9412 3.50247 12.6906C3.3987 12.44 3.23726 12.2174 3.03127 12.0409C2.82529 11.8645 2.58056 11.7391 2.317 11.675C0.561 11.249 0.561 8.751 2.317 8.325C2.5808 8.26108 2.82578 8.13578 3.032 7.95929C3.23822 7.7828 3.39985 7.56011 3.50375 7.30935C3.60764 7.05859 3.65085 6.78683 3.62987 6.51621C3.60889 6.24559 3.5243 5.98375 3.383 5.752C2.443 4.209 4.209 2.442 5.753 3.382C6.753 3.99 8.049 3.452 8.325 2.317Z"
        stroke=""
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 10C7 10.7956 7.31607 11.5587 7.87868 12.1213C8.44129 12.6839 9.20435 13 10 13C10.7956 13 11.5587 12.6839 12.1213 12.1213C12.6839 11.5587 13 10.7956 13 10C13 9.20435 12.6839 8.44129 12.1213 7.87868C11.5587 7.31607 10.7956 7 10 7C9.20435 7 8.44129 7.31607 7.87868 7.87868C7.31607 8.44129 7 9.20435 7 10Z"
        stroke=""
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,

    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.46704 18.3975H19.467M2.46704 18.3975V3.39746C2.46704 2.86703 2.67775 2.35832 3.05283 1.98325C3.4279 1.60817 3.93661 1.39746 4.46704 1.39746H16.467C16.9975 1.39746 17.5062 1.60817 17.8813 1.98325C18.2563 2.35832 18.467 2.86703 18.467 3.39746V18.3975"
        stroke=""
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.46704 18.3975V10.3975C7.46704 9.60181 7.78311 8.83875 8.34572 8.27614C8.90833 7.71353 9.67139 7.39746 10.467 7.39746C11.2627 7.39746 12.0258 7.71353 12.5884 8.27614C13.151 8.83875 13.467 9.60181 13.467 10.3975V18.3975"
        stroke=""
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,
  ];

  const unique_id = uuid();

  const stopProxyEmployee = async () => {
    // setLoading(true)
    const data = {
      user_id: User.id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: User.company_id,
      proxy_id: proxyEmployee?.id,
    };
    await axios
      .post(stopProxyEmployeeUrl, data)
      .then((res) => {
        if (res.data?.success) {
          toast.success(res.data?.data?.message);
          dispatch(
            payrollActions.updateProxy({
              success: false,
              id: "",
            })
          );
          if(User?.member_type==="Employee") {
            navigate("/employee-dashboard")
          } else if(User?.member_type==="Admin") {
            navigate("/dashboard")
          }
        }
      })
      .catch((err) => {
        // console.log('Get all payroll error',err.message)
        toast.error(err?.message);
      });
  };

  const [Toggle, setToggle] = useState(false);
  const [getIndex, setgetIndex] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const islognIn = useSelector((state) => state.payroll.isLogIn);
  const User = useSelector((state) => state.payroll.User);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);

  const dashboardTheme = window.localStorage.getItem("theme");

  useEffect(() => {}, [dashboardTheme]);

  const handleSublick = (index) => {
    setGetSubIndex((pre) => (pre = index));
  };

  const handle = () => {
    setToggle(false);
  };
  const Headerhandle = () => {
    setToggle((pre) => !pre);
    // console.log(Toggle)
  };
  const handleLogOut = () => {
    dispatch(LogOut());
    navigate("/");
  };

  const drawerWidth = 260;
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const container =
    window !== undefined ? () => window.document.body : undefined;

  useEffect(() => {
    if (matchUpMd) {
      setToggle(true);
    }
  }, [matchUpMd]);

  // const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  //     ...theme.typography.mainContent,
  //     ...(!open && {
  //         borderBottomLeftRadius: 0,
  //         borderBottomRightRadius: 0,
  //         transition: theme.transitions.create('margin', {
  //             easing: theme.transitions.easing.sharp,
  //             duration: theme.transitions.duration.leavingScreen
  //         }),
  //         [theme.breakpoints.up('md')]: {
  //             marginLeft: -(drawerWidth - 20),
  //             width: `calc(100% - ${drawerWidth}px)`
  //         },
  //         [theme.breakpoints.down('md')]: {
  //             marginLeft: '20px',
  //             width: `calc(100% - ${drawerWidth}px)`,
  //             padding: '16px'
  //         },
  //         [theme.breakpoints.down('sm')]: {
  //             marginLeft: '10px',
  //             width: `calc(100% - ${drawerWidth}px)`,
  //             padding: '16px',
  //             marginRight: '10px'
  //         }
  //     }),
  //     ...(open && {
  //         transition: theme.transitions.create('margin', {
  //             easing: theme.transitions.easing.easeOut,
  //             duration: theme.transitions.duration.enteringScreen
  //         }),
  //         marginLeft: 0,
  //         borderBottomLeftRadius: 0,
  //         borderBottomRightRadius: 0,
  //         width: `calc(100% - ${drawerWidth}px)`,
  //         [theme.breakpoints.down('md')]: {
  //             marginLeft: '20px'
  //         },
  //         [theme.breakpoints.down('sm')]: {
  //             marginLeft: '10px'
  //         }
  //     })
  // }));
  const location = useLocation();
  const Locate = location.pathname;
  const slide = Locate.slice(1);
  const handleLick = (index) => {
    if (index === getIndex) {
      setgetIndex("");
    } else {
      setgetIndex(index);
    }
  };

  // console.log(slide);
  const sidebarLinks =
    User?.member_type === "Employee" ||
    proxyEmployee?.member_type === "Employee"
      ? Employee_First_links
      : First_links;

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="nav"
        sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : "auto" }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant={matchUpMd ? "persistent" : "temporary"}
          anchor="left"
          open={Toggle}
          onClose={handle}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              background: theme.palette.background.default,
              color: theme.palette.text.primary,
              borderRight: "none",
              paddingTop: "0px",
              [theme.breakpoints.up("md")]: {
                top: "88px",
              },
            },
          }}
          ModalProps={{ keepMounted: true }}
          color="inherit"
        >
          <Box sx={{ overflow: "auto" }}>
            <div className="Logo_content" sx={{ flexGrow: 1 }}>
              <img src={logo} alt="avatar" className="logo" />
            </div>
            {sidebarLinks.map((item, index) =>
              item.hasChildren === false ? (
                <div
                  onClick={() => handleLick(index)}
                  className={`Link_Box ${getIndex === index ? "active" : ""}`}
                >
                  <div className="Left">
                    {item.icon}
                    <Link to={item.path} key={index}>
                      {item.name}
                    </Link>
                  </div>
                </div>
              ) : (
                item.hasChildren === true && (
                  <>
                    <div className="Dropdown_Rapper">
                      <div
                        onClick={() => handleLick(index)}
                        className={`Link_Box ${
                          getIndex === index ? "active" : ""
                        }`}
                      >
                        <div className="Left">
                          {item.icon}
                          <div>{item.name}</div>
                        </div>
                        {getIndex === index ? (
                          <KeyboardArrowDownIcon className="Arrow" />
                        ) : (
                          <ChevronRightIcon className="Arrow" />
                        )}
                      </div>
                      <div
                        className={`Dropdown_Wrap ${
                          getIndex === index ? "active" : ""
                        }`}
                      >
                        {item.children.map((list, Subindex) =>
                          list?.name !== "Run Payroll" ? (
                            <Link
                              onClick={() => handleSublick(Subindex)}
                              to={list.path}
                              key={Subindex}
                              className={`${
                                GetSubIndex === Subindex ? "active_link" : ""
                              }`}
                            >
                              {list.name}
                            </Link>
                          ) : User?.permissions?.data?.run_payroll === "1" ? (
                            <Link
                              onClick={() => handleSublick(Subindex)}
                              to={list.path}
                              key={Subindex}
                              className={`${
                                GetSubIndex === Subindex ? "active_link" : ""
                              }`}
                            >
                              {list.name}
                            </Link>
                          ) : null
                        )}
                      </div>
                    </div>
                    {/* <div className='divider'></div> */}
                  </>
                )
              )
            )}
            <span className="Log_Out_Btn_Box" onClick={handleLogOut}>
              <IoLogOutOutline /> log out
            </span>
          </Box>
        </Drawer>
      </Box>

      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
        open
      >
        <div className="Logo_content" sx={{ flexGrow: 1 }}>
          <img src={logo} alt="avatar" className="logo" />
        </div>
        {sidebarLinks.map((item, index) =>
          item.hasChildren === false ? (
            // <div style={{display:"flex", flexDirection: "row-reverse"}} >
            <div
              onClick={() => handleLick(index)}
              className={`Link_Box ${getIndex === index ? "active" : ""}`}
              style={{
                backgroundColor:
                  getIndex === index
                    ? dashboardTheme
                      ? dashboardTheme + "1F"
                      : "#13ABF41F"
                    : "",
              }}
            >
              {getIndex === index && (
                <div
                  className="borderLf"
                  style={{
                    borderColor: dashboardTheme ? dashboardTheme : "#13ABF4",
                  }}
                ></div>
              )}
              <div
                className="Left"
                style={{
                  color:
                    getIndex === index
                      ? dashboardTheme
                        ? dashboardTheme
                        : "#13ABF4"
                      : "",
                  stroke:
                    getIndex === index
                      ? dashboardTheme
                        ? dashboardTheme
                        : "#13ABF4"
                      : "",
                }}
              >
                {item.icon}
                <Link
                  style={{
                    color:
                      getIndex === index
                        ? dashboardTheme
                          ? dashboardTheme
                          : "#13ABF4"
                        : "",
                    stroke:
                      getIndex === index
                        ? dashboardTheme
                          ? dashboardTheme
                          : "#13ABF4"
                        : "",
                  }}
                  to={item.path}
                  key={index}
                >
                  {item.name}
                </Link>
              </div>
            </div>
          ) : (
            item.hasChildren === true && (
              <>
                <div className="Dropdown_Rapper">
                  <div
                    onClick={() => handleLick(index)}
                    className={`Link_Box ${getIndex === index ? "active" : ""}`}
                    style={{
                      backgroundColor:
                        getIndex === index
                          ? dashboardTheme
                            ? dashboardTheme + "1F"
                            : "#13ABF41F"
                          : "",
                    }}
                  >
                    <div className="DropdownLeft">
                      {getIndex === index && (
                        <div
                          className="borderLf"
                          style={{
                            borderColor: dashboardTheme
                              ? dashboardTheme
                              : "#13ABF4",
                          }}
                        ></div>
                      )}
                      <div
                        className="Left"
                        style={{
                          color:
                            getIndex === index
                              ? dashboardTheme
                                ? dashboardTheme
                                : "#13ABF4"
                              : "",
                          stroke:
                            getIndex === index
                              ? dashboardTheme
                                ? dashboardTheme
                                : "#13ABF4"
                              : "",
                          cursor: "pointer",
                        }}
                      >
                        {item.icon}
                        {item.name}
                      </div>
                    </div>
                    {getIndex === index ? (
                      <KeyboardArrowDownIcon className="Arrow" />
                    ) : (
                      <ChevronRightIcon className="Arrow" />
                    )}
                  </div>
                  <div
                    className={`Dropdown_Wrap ${
                      getIndex === index ? "active" : ""
                    }`}
                  >
                    {item.children.map((list, Subindex) =>
                      list?.name !== "Run Payroll" ? (
                        <Link
                          onClick={() => handleSublick(Subindex)}
                          to={list.path}
                          key={Subindex}
                          className={`${
                            GetSubIndex === Subindex ? "active_link" : ""
                          }`}
                          style={{
                            color:
                              GetSubIndex === Subindex
                                ? dashboardTheme
                                  ? dashboardTheme
                                  : "#13ABF4"
                                : "",
                          }}
                        >
                          {list.name}
                        </Link>
                      ) : User?.permissions?.data?.run_payroll === "1" ? (
                        <Link
                          onClick={() => handleSublick(Subindex)}
                          to={list.path}
                          key={Subindex}
                          className={`${
                            GetSubIndex === Subindex ? "active_link" : ""
                          }`}
                          style={{
                            color:
                              GetSubIndex === Subindex
                                ? dashboardTheme
                                  ? dashboardTheme
                                  : "#13ABF4"
                                : "",
                          }}
                        >
                          {list.name}
                        </Link>
                      ) : null
                    )}
                  </div>
                </div>
                <div className="divider"></div>
              </>
            )
          )
        )}
        <span className="Log_Out_Btn_Box" onClick={handleLogOut}>
          <IoLogOutOutline /> log out
        </span>
      </Drawer>

      <div className="Main">
        <Header Click={Headerhandle} />

        {/* <div className="Breadcrum">
                    <h2 style={{}}>{`${slide.replaceAll("-", " ")}`}</h2>
                </div> */}

        {islognIn ? <Outlet /> : navigate("/")}

        <div className="bottom_logo_wrap">
          <img src={bottom_logo} alt="avatar" />
        </div>
      </div>
    </Box>
    // <Routes>

    // </Routes>
  );
};

export default MainPageRoutes;
